"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsViewDetails = void 0;
const core_1 = require("@material-ui/core");
const filter_header_1 = require("client/components/filter-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_field_1 = require("client/components/material/text-field");
const menu_1 = require("client/components/menu");
const form_1 = require("client/components/ui/form");
const labels_view_scan_1 = require("client/modules/labels/modules/labels-view-scan");
const store_1 = require("client/modules/labels/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const claim_1 = require("shared/claim");
const print_labels_1 = require("shared/print-labels");
require("./labels-view-details.less");
const ReactTooltip = require("react-tooltip");
const moment = require("moment");
const columns = [
    {
        id: "patient.firstName",
        numeric: false,
        label: "Patient"
    },
    {
        id: "inventory.package",
        numeric: false,
        label: "NDC"
    },
    {
        id: "inventory.strengthDescription",
        numeric: false,
        label: "Inventory"
    },
    {
        id: "NO_ACTION",
        numeric: false,
        label: "Lot #"
    },
    {
        id: "NO_ACTION",
        numeric: false,
        label: "Qty"
    },
    {
        id: "NO_ACTION",
        numeric: false,
        label: ""
    }
];
const styles = core_1.createStyles({
    root: {},
    lotSearchItem: {
        overflow: "visible !important"
    },
    lotSearchField: {
        minWidth: "0px",
        width: "100%"
    },
    lotSearchMenu: {},
    listItem: {
        height: "auto",
        alignItems: "center"
    },
    buttonContainer: {
        "display": "flex",
        "& button": {
            width: "auto !important"
        }
    },
    labelPrinted: {
        background: "rgba(30, 193, 114, 0.15)"
    }
});
const decorate = core_1.withStyles(styles);
let LabelsViewDetailsUnstyled = class LabelsViewDetailsUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.order = "ASC";
        this.orderBy = "patient.firstName";
        this.showCompleted = false;
        this.errorMessage = "";
        this.showBarcodeScanModal = false;
        this.claimInventoriesMeta = new Map();
        this.rebuildTooltip = () => {
            ReactTooltip.rebuild();
        };
        this.loadPrescribedClaims = async () => {
            const query = {
                siteId: 1,
                count: 100,
                order: this.order,
                sort: this.orderBy,
                search: this.filterText,
                showCompleted: this.showCompleted,
                start: 0
            };
            this.orders = await store_1.labelsStore.listPrescribedClaims(query);
            this.initializeClaimInventoriesMeta();
        };
        this.getDummyClaimLotMeta = (init = {}) => {
            const dummyClaimLotMeta = {
                showMenu: false,
                filterText: "",
                lot: null,
                qty: 0
            };
            return Object.assign(Object.assign({}, dummyClaimLotMeta), init);
        };
        this.initializeClaimInventoriesMeta = () => {
            const { value: prescribedClaims } = store_1.labelsStore.prescribedClaims;
            for (const claim of prescribedClaims) {
                if (!this.claimInventoriesMeta.has(claim.id)) {
                    if (claim.claimLots.length) {
                        const initialMeta = claim.claimLots.map(cl => this.getDummyClaimLotMeta({
                            qty: cl.qtyUsed,
                            lot: cl.siteLot,
                            filterText: cl.siteLot.lotNumber
                        }));
                        this.claimInventoriesMeta.set(claim.id, initialMeta);
                    }
                    else {
                        const dummyMeta = [
                            this.getDummyClaimLotMeta({ qty: claim.quantity })
                        ];
                        this.claimInventoriesMeta.set(claim.id, dummyMeta);
                    }
                }
            }
        };
        this.handleToggle = () => {
            this.showCompleted = !this.showCompleted;
            this.loadPrescribedClaims();
        };
        this.handleBarcodeScanModalCancel = () => {
            this.showBarcodeScanModal = false;
        };
        this.getIndex = (claim) => {
            const meta = this.claimInventoriesMeta.get(claim.id);
            return meta.length ? meta.length - 1 : 0;
        };
        this.handleBarcodeScanModalSubmit = (scannedList) => {
            const claim = this.scannedClaim;
            const index = this.getIndex(claim);
            const [scannedItemRaw] = scannedList;
            const [pkg, [rawData]] = scannedItemRaw;
            const scannedLotNumber = rawData ? rawData.lot : null;
            // const scannedLotNumber = "testx";
            const inventorySiteLots = this.getInventorySiteLots(claim);
            const options = this.getFilteredData(claim, inventorySiteLots, index);
            const item = options.find(option => option.label === scannedLotNumber);
            if (claim && item) {
                this.handleOnMenuAction(claim, index)(item);
            }
            else {
                this.errorMessage = `Lot ${scannedLotNumber} not found`;
                this.resetErrorMessageTimeout(5000);
            }
        };
        this.resetErrorMessageTimeout = (ms) => {
            setTimeout(() => (this.errorMessage = ""), ms);
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadPrescribedClaims();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPrescribedClaims();
        };
        this.handleSearch = (claim, index) => (event, value) => {
            if (this.claimInventoriesMeta.has(claim.id)) {
                const updated = this.claimInventoriesMeta.get(claim.id);
                updated[index].showMenu = true;
                updated[index].filterText = value;
                this.claimInventoriesMeta.set(claim.id, updated);
            }
        };
        this.addNewLotField = (claim, init = {}) => {
            const newUpdated = this.claimInventoriesMeta.get(claim.id);
            newUpdated.push(this.getDummyClaimLotMeta(init));
            this.claimInventoriesMeta.set(claim.id, newUpdated);
        };
        this.handleLotQtyChange = (claim, index) => (event, value) => {
            if (!this.claimInventoriesMeta.has(claim.id)) {
                return;
            }
            const normalizedValue = Number(value) > 0 ? Number(value) : 0;
            const inventorySiteLots = this.getInventorySiteLots(claim);
            const updated = this.claimInventoriesMeta.get(claim.id);
            if (value === "") {
                updated[index].qty = "";
                this.claimInventoriesMeta.set(claim.id, updated);
            }
            else if (normalizedValue === 0 && index > 0) {
                updated.splice(index, 1);
                this.claimInventoriesMeta.set(claim.id, updated);
            }
            else {
                if (!updated[index].lot) {
                    updated[index].qty = 0;
                    this.claimInventoriesMeta.set(claim.id, updated);
                }
                else {
                    const claimQty = claim.quantity;
                    const inventorySiteLotFound = inventorySiteLots.find(isl => Number(isl.id) === Number(updated[index].lot.id));
                    const availableLotQty = inventorySiteLotFound
                        ? inventorySiteLotFound.quantity
                        : 0;
                    const allSelectedLots = this.claimInventoriesMeta.get(claim.id) || [];
                    const hasAvailableLotQty = availableLotQty > 0;
                    const qtyWithinAvailableLotQty = normalizedValue <= availableLotQty;
                    const potentialNewUsedQty = allSelectedLots.reduce((acc, cur) => {
                        if (cur.lot &&
                            Number(cur.lot.id) === Number(inventorySiteLotFound.id)) {
                            return acc + normalizedValue;
                        }
                        else {
                            return acc + Number(cur.qty);
                        }
                    }, 0);
                    const potentialNewUsedQtyIsValid = potentialNewUsedQty <= claimQty;
                    const shouldUpdateQty = hasAvailableLotQty &&
                        qtyWithinAvailableLotQty &&
                        potentialNewUsedQtyIsValid;
                    if (shouldUpdateQty) {
                        const qtyDecremented = normalizedValue < updated[index].qty;
                        updated[index].qty = normalizedValue;
                        this.claimInventoriesMeta.set(claim.id, updated);
                        const shouldAddNewLotField = qtyDecremented && !updated[index + 1];
                        if (shouldAddNewLotField) {
                            this.addNewLotField(claim, { qty: this.getNewLotFieldQty(claim) });
                        }
                    }
                }
            }
        };
        this.getNewLotFieldQty = (claim) => {
            if (!this.claimInventoriesMeta.has(claim.id)) {
                return 0;
            }
            const newQty = claim.quantity -
                this.claimInventoriesMeta
                    .get(claim.id)
                    .reduce((acc, cur) => this.add(acc, cur.qty), 0);
            return newQty >= 0 ? newQty : 0;
        };
        this.calculateLotToUseQty = (lot, currentSetQty) => {
            const availableLotQty = lot.quantity;
            let qtyToUse = currentSetQty;
            if (availableLotQty < Number(currentSetQty)) {
                qtyToUse = availableLotQty;
            }
            return qtyToUse;
        };
        this.getInventorySiteLots = (claim) => {
            const { order, inventory } = claim;
            const { sites: inventorySites } = inventory;
            const inventorySiteFound = inventorySites.find(is => is.inventoryId === inventory.id && is.siteId === order.siteId);
            return inventorySiteFound ? inventorySiteFound.inventorySiteLots : [];
        };
        this.getInventorySite = (claim) => {
            const { order, inventory } = claim;
            const { sites: inventorySites } = inventory;
            const inventorySiteFound = inventorySites.find(is => is.inventoryId === inventory.id && is.siteId === order.siteId);
            return inventorySiteFound;
        };
        /**
         * Set filterText to the label of the selected item, set the item selected to quickSearchSelection
         */
        this.handleOnMenuAction = (claim, index) => (item) => {
            console.info("menu action triggered");
            if (!this.claimInventoriesMeta.has(claim.id)) {
                return;
            }
            const inventorySiteLots = this.getInventorySiteLots(claim);
            const inventorySiteLotFound = inventorySiteLots.find(isl => Number(isl.id) === Number(item.id));
            const updated = this.claimInventoriesMeta.get(claim.id);
            updated[index].filterText = item.label;
            updated[index].lot = inventorySiteLotFound;
            updated[index].qty = this.calculateLotToUseQty(inventorySiteLotFound, updated[index].qty);
            this.claimInventoriesMeta.set(claim.id, updated);
        };
        /**
         *  Filter matched from filterText
         */
        this.getMatchedFilterText = (claim, index) => (item) => {
            const filterText = this.claimInventoriesMeta.has(claim.id)
                ? this.claimInventoriesMeta.get(claim.id)[index].filterText
                : "";
            return item.lotNumber
                .toLowerCase()
                .trim()
                .includes(filterText.toLowerCase().trim());
        };
        /**
         * Filter out selected lot
         */
        this.filterMatchedNonSelected = (claim, index) => (item) => {
            const claimInventoryMeta = this.claimInventoriesMeta.has(claim.id)
                ? this.claimInventoriesMeta.get(claim.id)
                : null;
            return claimInventoryMeta
                ? !claimInventoryMeta.find(clm => clm.lot ? String(clm.lot.id) === String(item.id) : false)
                : false;
        };
        this.filterValidLotQty = (item) => {
            return item.quantity > 0;
        };
        this.getFilteredData = (claim, inventorySiteLots, index, matchFilterText = true) => {
            let options = inventorySiteLots
                .filter(this.filterValidLotQty)
                .filter(this.filterMatchedNonSelected(claim, index))
                .filter(e => moment(e.expirationDate).isSameOrAfter(moment()));
            if (matchFilterText) {
                options = options.filter(this.getMatchedFilterText(claim, index));
            }
            return options.map(isl => ({
                id: String(isl.id),
                label: String(isl.lotNumber),
                value: String(isl.id)
            }));
        };
        this.renderLotNumberTextField = (claim, inventorySiteLots) => {
            const claimLotMeta = this.claimInventoriesMeta.has(claim.id)
                ? this.claimInventoriesMeta.get(claim.id)
                : null;
            const labelPrinted = !!claim.labelPrinted;
            if (claimLotMeta) {
                return (React.createElement("div", null, claimLotMeta.map((clm, index) => {
                    const showMenu = this.claimInventoriesMeta.has(claim.id)
                        ? this.claimInventoriesMeta.get(claim.id)[index].showMenu
                        : false;
                    const filterText = this.claimInventoriesMeta.has(claim.id)
                        ? this.claimInventoriesMeta.get(claim.id)[index].filterText
                        : "";
                    const data = this.getFilteredData(claim, inventorySiteLots, index);
                    if (!data.length && !filterText) {
                        return React.createElement("p", { style: { textAlign: "center" } }, "No Lots Available");
                    }
                    return (React.createElement(menu_1.Menu, { key: index, className: this.props.classes.lotSearchMenu, data: data, showMenu: showMenu, onAction: this.handleOnMenuAction(claim, index) },
                        React.createElement(text_field_1.MaterialTextField, { disabled: labelPrinted, placeholder: claimLotMeta[index].lot
                                ? claimLotMeta[index].lot.lotNumber
                                : "", className: this.props.classes.lotSearchField, label: "Lot#", value: filterText, onChange: this.handleSearch(claim, index), onBlur: this.handleOnBlur(claim, index), onFocus: this.handleOnFocus(claim, index) })));
                })));
            }
            return null;
        };
        this.renderLotQtyTextField = (claim) => {
            const claimLotMeta = this.claimInventoriesMeta.has(claim.id)
                ? this.claimInventoriesMeta.get(claim.id)
                : null;
            const labelPrinted = !!claim.labelPrinted;
            if (claimLotMeta) {
                return (React.createElement("div", null, claimLotMeta.map((clm, index) => {
                    const availableLotQty = this.claimInventoriesMeta.has(claim.id)
                        ? this.claimInventoriesMeta.get(claim.id)[index].qty
                        : 0;
                    return (React.createElement(menu_1.Menu, { key: index, data: [], showMenu: false, onAction: () => { } },
                        React.createElement(text_field_1.MaterialTextField, { disabled: labelPrinted, className: this.props.classes.lotSearchField, label: "Lot Qty", type: "number", value: availableLotQty, onChange: this.handleLotQtyChange(claim, index), onBlur: this.handleLotQtyOnBlur(claim, index) })));
                })));
            }
            return null;
        };
        this.getPrintableClaims = () => {
            return store_1.labelsStore.prescribedClaims.value.filter(claim => this.isSaveableClaim(claim));
        };
        this.handleClear = (claim) => async () => {
            this.claimInventoriesMeta.has(claim.id) &&
                this.claimInventoriesMeta.set(claim.id, [
                    this.getDummyClaimLotMeta({ qty: claim.quantity })
                ]);
            await store_1.labelsStore.clearClaimLots(claim);
            this.loadPrescribedClaims();
        };
        this.handleSaveAll = (action) => async () => {
            const claims = this.getPrintableClaims();
            const claimMetas = claims.map(claim => ({
                claim,
                claimLotMetas: this.claimInventoriesMeta.get(claim.id)
            }));
            await store_1.labelsStore.updateClaimLots(claimMetas, action || "save");
            this.loadPrescribedClaims();
        };
        this.handlePrintAll = async () => {
            const claims = this.getPrintableClaims();
            await this.handleSaveAll("print")();
            await store_1.labelsStore.printLabels(claims, "labels");
        };
        this.handleSave = (claim, action) => async () => {
            const claimLotMetas = this.claimInventoriesMeta.get(claim.id);
            const claimMetas = [{ claim, claimLotMetas }];
            await store_1.labelsStore.updateClaimLots(claimMetas, action || "save");
            this.loadPrescribedClaims();
        };
        this.handlePrint = (claim) => async () => {
            await this.handleSave(claim, "print")();
            await store_1.labelsStore.printLabels([claim], "labels");
        };
        this.handleScan = (claim) => () => {
            console.info("handle scan triggered");
            this.showBarcodeScanModal = true;
            this.scannedClaim = claim;
        };
        this.handleOnBlur = (claim, index) => () => {
            if (this.claimInventoriesMeta.has(claim.id)) {
                const updated = this.claimInventoriesMeta.get(claim.id);
                updated[index].showMenu = false;
                if (updated[index].lot) {
                    updated[index].filterText = updated[index].lot.lotNumber;
                }
                this.claimInventoriesMeta.set(claim.id, updated);
            }
        };
        this.handleLotQtyOnBlur = (claim, index) => () => {
            if (this.claimInventoriesMeta.has(claim.id)) {
                const updated = this.claimInventoriesMeta.get(claim.id);
                if (updated[index].qty === "") {
                    updated[index].qty = 0;
                    this.claimInventoriesMeta.set(claim.id, updated);
                }
            }
        };
        this.handleOnFocus = (claim, index) => () => {
            if (this.claimInventoriesMeta.has(claim.id)) {
                const updated = this.claimInventoriesMeta.get(claim.id);
                updated[index].showMenu = true;
                this.claimInventoriesMeta.set(claim.id, updated);
            }
        };
        this.add = (n1, n2) => Number(n1) + Number(n2);
        this.getLotsQtyUsed = (claim) => {
            return this.claimInventoriesMeta.has(claim.id)
                ? this.claimInventoriesMeta
                    .get(claim.id)
                    .reduce((acc, cur) => this.add(acc, cur.qty), 0)
                : 0;
        };
        /**
         * Disable save if total lot qty used not equal claim quantity
         */
        this.isSaveableClaim = (claim) => {
            const claimQty = claim.quantity;
            const claimLotMeta = this.claimInventoriesMeta.get(claim.id);
            if (!claimLotMeta) {
                return true;
            }
            const totalUsedQty = claimLotMeta.reduce((acc, cur) => this.add(acc, cur.qty), 0);
            const validUsedQty = claimQty === totalUsedQty;
            const validLotsQty = claimLotMeta.every(clm => clm.lot ? clm.lot.quantity >= clm.qty : clm.qty === 0);
            const validInventorySiteQty = this.isValidInventorySiteQty(claim);
            return validInventorySiteQty && validUsedQty && validLotsQty;
        };
        this.isValidInventorySiteQty = (claim) => {
            const inventorySite = this.getInventorySite(claim);
            const validInventorySiteQty = inventorySite.quantity >= claim.quantity;
            return validInventorySiteQty;
        };
        // public isPrintableClaim = (claim: IClaim) => {
        //   const claimQty = claim.quantity;
        //   const totalClaimLotsQty = claim.claimLots.reduce(
        //     (acc, cur) => this.add(acc, cur.qtyUsed),
        //     0
        //   );
        //   const isPrintableClaim = claimQty === totalClaimLotsQty;
        //   return isPrintableClaim;
        // };
        this.findInventorySite = (claim) => {
            const { order, inventory } = claim;
            const { sites: inventorySites } = inventory;
            const inventorySiteFound = inventorySites.find(is => is.inventoryId === inventory.id && is.siteId === order.siteId);
            return inventorySiteFound;
        };
        this.generateDataTip = (claim) => {
            let message = "";
            const isValidInventorySiteQty = this.isValidInventorySiteQty(claim);
            const isValidLotSelection = this.isValidLotSelection(claim);
            if (!isValidInventorySiteQty) {
                const inventorySite = this.getInventorySite(claim);
                message = `Inventory quantity (${inventorySite.quantity}) is less than claim quantity (${claim.quantity})`;
            }
            else if (!isValidLotSelection) {
                message = `Inventory lot not selected`;
            }
            else {
                message = `Lots quantity (${this.getLotsQtyUsed(claim)}) does not match claim quantity (${claim.quantity})`;
            }
            return message;
        };
        this.renderTableRow = (row, index) => {
            var _a, _b;
            const { order, inventory } = row;
            const { patient } = order;
            const patientName = `${patient.lastName}, ${patient.firstName}`;
            const ndc = inventory.package;
            const inventoryName = inventory.strengthDescription ||
                inventory.name ||
                inventory.generic ||
                "";
            const inventorySiteFound = this.findInventorySite(row);
            const inventorySiteLots = inventorySiteFound
                ? inventorySiteFound.inventorySiteLots
                : [];
            const disableSave = !this.isSaveableClaim(row);
            const disablePrint = disableSave;
            const labelPrinted = !!row.labelPrinted;
            const completeStatuses = [claim_1.ClaimStatus.Dispensed, claim_1.ClaimStatus.Intended];
            const thisOrder = (_a = this.orders) === null || _a === void 0 ? void 0 : _a.find(o => o.id === order.id);
            const doneOrder = (_b = thisOrder === null || thisOrder === void 0 ? void 0 : thisOrder.claims) === null || _b === void 0 ? void 0 : _b.some(c => completeStatuses.includes(c.status));
            const hideLabel = doneOrder && !completeStatuses.includes(row.status);
            const qty = inventorySiteFound.quantity >= row.quantity;
            if (!qty || hideLabel)
                return React.createElement(React.Fragment, null);
            return (React.createElement(list_item_1.MaterialListItem, { key: index, className: `${this.props.classes.listItem}${labelPrinted ? ` ${this.props.classes.labelPrinted}` : ""}` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: patientName }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: ndc }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: inventoryName }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: this.props.classes.lotSearchItem, primary: this.renderLotNumberTextField(row, inventorySiteLots) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: this.renderLotQtyTextField(row) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: this.props.classes.buttonContainer },
                        React.createElement("div", { "data-tip": disableSave ? this.generateDataTip(row) : "" },
                            React.createElement(button_1.MaterialButton, { onClick: this.handleSave(row), disabled: disableSave || row.labelPrinted !== print_labels_1.LabelPrintStatus.Cleared, primary: true }, "save")),
                        React.createElement(button_1.MaterialButton, { disabled: doneOrder, onClick: this.handleClear(row) }, "Clear"),
                        React.createElement(button_1.MaterialButton, { onClick: this.handlePrint(row), disabled: disablePrint, primary: true }, "print"),
                        React.createElement(button_1.MaterialButton, { disabled: labelPrinted, onClick: this.handleScan(row), secondary: true }, "scan")) })));
        };
        this.renderPads = () => {
            const pads = [1, 2, 3, 4];
            return pads.map(pad => React.createElement(core_1.Typography, null, "pad"));
        };
        this.renderTable = () => {
            return (React.createElement("div", { className: "sites__list" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_1.labelsStore.prescribedClaims.value, renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__prescribed-labels-list" })));
        };
    }
    componentDidUpdate() {
        this.rebuildTooltip();
    }
    async componentDidMount() {
        await this.loadPrescribedClaims();
    }
    render() {
        return (React.createElement(form_1.UiForm, { className: this.props.classes.root, buttons: [
                React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleSaveAll() }, "Save All"),
                "Print All"
            ], onSubmit: this.handlePrintAll, loading: store_1.labelsStore.prescribedClaims.loading, error: store_1.labelsStore.prescribedClaims.error || this.errorMessage },
            React.createElement("div", { className: "labels-view-details" },
                React.createElement(filter_header_1.FilterHeader, { label: "Search", title: " ", withSwitch: true, switchLabel: "Show Completed", switchChecked: this.showCompleted, handleToggle: this.handleToggle, callBack: this.onCallback, filterText: this.filterText }),
                this.renderTable(),
                React.createElement(ReactTooltip, { effect: "solid", place: "left" })),
            this.showBarcodeScanModal ? (React.createElement(labels_view_scan_1.LabelsViewScan, { onCancel: this.handleBarcodeScanModalCancel, onSubmit: this.handleBarcodeScanModalSubmit })) : null));
    }
    isValidLotSelection(claim) {
        const claimLotMeta = this.claimInventoriesMeta.get(claim.id);
        return claimLotMeta && claimLotMeta.every(clm => clm.lot);
    }
};
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "showCompleted", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "scannedClaim", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "showBarcodeScanModal", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "claimInventoriesMeta", void 0);
__decorate([
    mobx_1.observable
], LabelsViewDetailsUnstyled.prototype, "orders", void 0);
LabelsViewDetailsUnstyled = __decorate([
    mobx_react_1.observer
], LabelsViewDetailsUnstyled);
exports.LabelsViewDetails = decorate(LabelsViewDetailsUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/modules/labels-view-details/labels-view-details.tsx
// module id = 3701
// module chunks = 0